module.exports = __webpack_public_path__ + "static/media/H.f54d70a0.webp";